import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-08f29451"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contract-info-page" }
const _hoisted_2 = { class: "info-label" }
const _hoisted_3 = { class: "info-value" }
const _hoisted_4 = {
  key: 1,
  class: "el-card cm-align-center",
  style: {"height":"100%","justify-content":"center"}
}

import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { formatTimeStamp } from '@/utils/time'
import { ContractInfoService, ResponseData } from './service'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { t, te, locale } = useI18n()

const injector = useReflectiveInjector([ContractInfoService])
const contractInfoService = injector.get(ContractInfoService)

const isLoading = ref(false)
const contractInfo = ref<ResponseData>({})

const hasInfo = computed(() => Object.keys(contractInfo.value).length > 0)

const expiresText = computed(() => {
  void locale.value
  return formatTimeStamp(contractInfo.value.expires_time_stamp, 'YYYY-MM-DD') || '--'
})

function countText(value: number | undefined): string {
  return value == null ? '--' : `${value} ${t('mySubscribe.terminalUnit')}`
}

function permissionNames(ids?: number[]): string {
  if (!ids?.length) return '--'
  return ids
    .map((id) => {
      const key = `contractInfo.permissionByPriceId.${id}`
      return te(key) ? t(key) : String(id)
    })
    .join(t('contractInfo.serviceSeparator'))
}

const infoRows = computed(() => {
  void locale.value
  const info = contractInfo.value
  return [
    { label: t('contractInfo.combineType'), value: info.combine_type === 1 ? t('contractInfo.baseCombine'):t('contractInfo.allCombine') || '--' },
    // { label: t('contractInfo.subscribedServices'), value: permissionNames(info.price_ids), type:'tag' },
    { label: t('contractInfo.validityPeriod'), value: expiresText.value },
    { label: t('contractInfo.joinedTerminalCount'), value: countText(info.join_count) },
    { label: t('contractInfo.subscribeCount'), value: countText(info.terminal_count) },
  ]
})

function getContractInfo() {
  isLoading.value = true
  contractInfoService
    .getPermissionOrderOrderInfo()
    .then((response) => {
      contractInfo.value = response || {}
    })
    .finally(() => {
      isLoading.value = false
    })
}

getContractInfo()

return (_ctx: any,_cache: any) => {
  const _component_el_card = _resolveComponent("el-card")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    (hasInfo.value)
      ? (_openBlock(), _createBlock(_component_el_card, {
          key: 0,
          class: "contract-info-card",
          shadow: "never"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(infoRows.value, (row, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "info-row"
              }, [
                _createElementVNode("span", _hoisted_2, _toDisplayString(row.label), 1),
                _createElementVNode("span", _hoisted_3, _toDisplayString(row.value), 1)
              ]))
            }), 128))
          ]),
          _: 1
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.$t('common.noData')), 1))
  ])), [
    [_directive_loading, isLoading.value]
  ])
}
}

})